import React from "react";
import PropTypes from "prop-types";
import LinkItem from "../../../components/LinkItem/LinkItem";
import RewardDescription from "./RewardDescription";
import RewardBoxWrapper from "./RewardBoxWrapper";
import { useTheme } from "styled-components";

const RewardBox = props => {
  const {
    iconName,
    linkText,
    handleClick,
    dataTestId,
    href,
    trackingInfo,
    children,
    showArrow,
    bonusDescription
  } = props;

  const theme = useTheme();

  return (
    <RewardBoxWrapper>
      <LinkItem
        iconName={iconName}
        linkText={linkText}
        handleClick={handleClick}
        dataTestId={dataTestId}
        href={href}
        trackingInfo={trackingInfo}
        showArrow={showArrow}
        iconColor={theme.linkItem.icon.defaultColor}
        isArrowStatic={true}
        {...children}
      />
      <RewardDescription text={bonusDescription} color="#CCCCCC" />
    </RewardBoxWrapper>
  );
};

RewardBox.propTypes = {
  iconName: PropTypes.string,
  linkText: PropTypes.string,
  handleClick: PropTypes.func,
  dataTestId: PropTypes.string,
  href: PropTypes.string,
  trackingInfo: PropTypes.object,
  children: PropTypes.node,
  showArrow: PropTypes.bool,
  bonusDescription: PropTypes.string
};
export default React.memo(RewardBox);
